import React from 'react';
import ReactDOM from 'react-dom';
import './episodes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


/* ---------------------RESOURCES--------------------- */
class Ep extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="longerPage container-fluid">
                <span class="topButtons"><button className="eButton"><Link to="/Episodes">Episodes</Link></button><button className="hButton"><Link to="/">Home</Link></button></span>

                
                {/*Titles*/}
                <div className="row">
                    <div className="title-wrapper col-12">
                        <h1 className="title">Season 2, Episode 3: Queen SeonDeok and the Odorless Flowers</h1>
                        <h5 className="korean-title">시즌 2, 에피소드 3: 선덕여왕</h5>
                    </div>
                </div>

                {/*VOCABULARY*/}
                <div class="vocabList">

<span class="italics">Listen to the episode <a target="_blank" href="https://anchor.fm/learn-korean-culture/episodes/S2--Episode-3-Queen-SeonDeok-and-the-Odorless-Flowers-e150r75">here</a>!</span> <br></br>
<br></br>

{/* INTRO */}
여왕 (yuh wang) — queen <br></br>
선덕여왕 (Seon Deok yuh wang) — Queen SeonDeok <br></br>
<br></br>Pictured below: Portrait of Queen Seondeok
<br></br><img className="epPic-m" src="https://64.media.tumblr.com/aa12579ed0e0543cf914276f8df9c7c4/tumblr_mphf1mXXFg1qkyzm3o1_400.jpg"></img><br></br><br></br>
즉위하다 (jeuk we ha da) — to take the throne <br></br>
딸 (ttal) — daughter <br></br>
진평왕 (Jin Pyung wang) — the previous king of the Silla Kingdom, which is one of the three kingdoms that ruled the Korean peninsula in this time period <br></br>
아들 (ah deul) — son <br></br>
제27대 (jae eeh ship chil dae) — the 27th <br></br>
왕 (wang) — king or ruler <br></br>
동아시아 (dong ah shi ah) — East Asia <br></br>

<br></br>
{/* LEGENDARY STORY */}
유명하다 (yu myeong ha da) — to be famous <br></br>
전설 (jeon seol) — legend <br></br>
이야기 (eeh yah gi) — story <br></br>

당 태종 (dang tae jong) — ruler of 당나라, which was a nation in modern day China <br></br>
빨강 (ppal gang) — red <br></br>
자주 (jah ju) — purple <br></br>
하얀색 (ha yan saek) — white <br></br>
모란 (mo ran) — Chinese mudan, which is a type of flower <br></br>
그림 (geu rim) — painting or drawing <br></br>
씨앗 (ssi aht) — seeds <br></br>
선물 (sun mul) — present <br></br>
보내다 (bo nae da) — to send <br></br>

<br></br>
{/* ODORLESS FLOWERS */}
꽃 (kkot) — flower <br></br>
향기 (hyang gi) —fragrance <br></br>
없다 (up da) — to not exist <br></br>
씨앗을 심다 (ssi aht eul sim da) — to plant the seeds <br></br>
정말 그랬습니다 (jung mal geu raet seum ni da)— it really was that way <br></br>
꽃 그림 (kkot geu rim) — flower painting <br></br>
나비 (nah bi) — butterfly <br></br>
배우자 (bae woo jah) — spouse <br></br>
희롱하다 (hi rong ha da) — to mock <br></br>

<br></br>
{/* HER IMPACT AND CONCLUSIONS */}
천문대 (chun moon dae) — astronomical observatory <br></br>
<br></br>Pictured below: 첨성대, the Chunmoondae astronomical observatory
<br></br><img className="epPic-m" src="https://upload.wikimedia.org/wikipedia/commons/e/e2/Cheomseongdae-1.jpg"></img><br></br><br></br>
일 년 (il nyeon) — one year <br></br>
농민 (nong min) — farmers <br></br>
세금 (sae geum) — tax <br></br>
안 받다 (ahn badt da) — to not receive <br></br>
평민 (pyeong min) — common people <br></br>
삼국사기 (sam guk sa gi) — the historical record of the Three Kingdoms of Korea, 고구려, 백제, and 신라 <br></br>
<br></br>Pictured below: a page of 삼국사기 (samguk sagi)
<br></br><img className="epPic-m" src="https://upload.wikimedia.org/wikipedia/commons/d/de/Samguk.JPG"></img><br></br><br></br>
역사 (yeok sah) — history <br></br>


                </div>
                <div className="row"><div className="col-12 spacer5"></div></div>
            </div>


        )
    }
}


/* -------------------------Variables------------------------- */
function App() {
    return (
        <div>
        <Ep></Ep>
        </div>
    );
}


  const Episode = () => (
    <div className='app'>
        <App />
    </div>
  );


export default Episode;